import { NgModule } from '@angular/core';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { EquipmentsTypesApi } from 'app/main/settings/registers/equipments-types/services/api/equipments-types-api.service';

import { EquipmentsTypeSelectComponent } from './equipments-type-select.component';

@NgModule({
  entryComponents: [
    EquipmentsTypeSelectComponent
  ],
  declarations: [
    EquipmentsTypeSelectComponent
  ],
  imports: [
    FuseSharedModule,
    TranslateModule,

    MatSelectModule,
    MatTooltipModule
  ],
  exports: [
    EquipmentsTypeSelectComponent
  ],
  providers: [
    EquipmentsTypesApi
  ]
})
export class EquipmentsTypeSelectModule { }
